import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { LANDING } from "../../constants/testIds";

// Le candidature vivono su Typeform: questa rotta è solo una scorciatoia per Giulia,
// che da lì consulta le risposte e scarica il CSV.
const RESULTS_URL = process.env.REACT_APP_TYPEFORM_RESULTS_URL;

export default function AdminRedirect() {
  useEffect(() => {
    if (RESULTS_URL) {
      window.location.replace(RESULTS_URL);
    }
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-beige py-12 px-6"
      data-testid={LANDING.adminRedirectContainer}
    >
      <div className="w-full max-w-md bg-white border border-chocolate/10 p-8 space-y-6 relative text-center">
        <div className="absolute top-0 left-0 right-0 h-1 bg-bordeaux" />

        <h1 className="text-2xl font-editorial text-chocolate mt-4">BACK TO YOU™</h1>

        {RESULTS_URL ? (
          <>
            <p className="text-sm text-chocolate/70 font-light">
              Ti stiamo portando alle candidature su Typeform...
            </p>
            <a
              href={RESULTS_URL}
              className="inline-flex items-center justify-center bg-bordeaux text-white hover:bg-bordeaux-hover text-xs font-semibold tracking-widest px-6 py-4 transition-luxury"
              data-testid={LANDING.adminResultsLink}
            >
              APRI LE CANDIDATURE <ExternalLink className="w-3.5 h-3.5 ml-2" />
            </a>
          </>
        ) : (
          <p className="text-sm text-chocolate/70 font-light">
            Le candidature si consultano su Typeform. Il collegamento non è ancora
            configurato: imposta <code className="font-mono text-xs">REACT_APP_TYPEFORM_RESULTS_URL</code>.
          </p>
        )}

        <Link
          to="/"
          className="inline-flex items-center text-xs tracking-wider text-chocolate/60 hover:text-bordeaux font-semibold uppercase"
        >
          <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Torna alla Home
        </Link>
      </div>
    </div>
  );
}
